import ROLES from 'config/roles';

export const VIEW_ALL_COMPANIES_ROLES = [ROLES.QM_ADMIN];

export const ADD_COMPANIES_ROLES = [ROLES.QM_ADMIN];

export const LOGIN_COMPANIES_ROLES = [ROLES.QM_ADMIN];
